import { PdsLoadingPage } from "@principal/design-system-react";
import React from "react";

const AuthLoader = () => {
    return (
        <PdsLoadingPage/>
    );
}
export default AuthLoader;
